import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
// import ArticleBundleItem from "../article-bundle-item";
import { fetchCollection } from "../../../api";
import styles from "./styles.m.css";
import SmallStoryCardCurve from "../small-story-card-with-curve";

const LatestNewsStories = ({
  className = "",
  collectionSlug = "gold-story-page",
  title = "லேட்டஸ்ட் தங்கம் / வெள்ளி செய்திகள்"
}) => {
  const pageNumber = 0;
  const limit = 5;
  const [stories, setData] = useState([]);

  useEffect(() => {
    fetchCollection(collectionSlug, pageNumber, limit, {}, "story").then(response => {
      setData(response["items"]);
    });
  }, []);

  return (
    <div className={`${styles["base"]} ${className}`}>
      <h2 className={styles["title"]}>{title}</h2>
      <div className={styles["collections-wrap"]}>
        {stories &&
          stories.map(
            story =>
              story && (
                <SmallStoryCardCurve
                  key={story.id}
                  story={story.story}
                  className={styles["collection-item"]}
                  goldpage={true}
                />
              )
          )}
      </div>
    </div>
  );
};

LatestNewsStories.propTypes = {
  className: PropTypes.string,
  goldpage: PropTypes.bool,
  collectionSlug: PropTypes.string,
  title: PropTypes.string
};

export default LatestNewsStories;
